import React, { useEffect } from "react";
import { Card, Grid, GridColumn, Separator } from "@atlassiansox/microscopekit";
import { useFaults } from "../useFaults";
import { FaultEditor } from "../FaultEditor";
import { FaultsList } from "../FaultsList";
export var FaultsManager = function (_a) {
    var value = _a.value, onChange = _a.onChange, containersForService = _a.containersForService, microsGroupsForService = _a.microsGroupsForService, serviceId = _a.serviceId, environment = _a.environment;
    var _b = useFaults(value), faults = _b.faults, editFault = _b.editFault, deleteFault = _b.deleteFault, faultBeingEdited = _b.faultBeingEdited, saveFault = _b.saveFault, cancelFault = _b.cancelFault, faultBeingEditedIndex = _b.faultBeingEditedIndex;
    useEffect(function () {
        onChange(faults);
    }, [faults, onChange]);
    return (React.createElement(Card, null,
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 6 },
                React.createElement("h4", null, "Add Faults"),
                React.createElement(FaultEditor, { value: faultBeingEdited, onSave: saveFault, onCancel: cancelFault, containersForService: containersForService, microsGroupsForService: microsGroupsForService, serviceId: serviceId, environment: environment, faultBeingEditedIndex: faultBeingEditedIndex })),
            React.createElement(GridColumn, { medium: 6 },
                React.createElement("h3", null, "Faults Preview"),
                React.createElement(Separator, null),
                React.createElement(FaultsList, { faults: faults, onEdit: editFault, onDelete: deleteFault })))));
};
